// src/routes/SmsConfigRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';
import SmsConfigPage from '../pages/settings/sms/SmsConfigPage';

const SmsConfigRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PermissionRoute requiredPermission="manage_sms_config">
            <SmsConfigPage />
          </PermissionRoute>
        }
      />
    </Routes>
  );
};

export default SmsConfigRoutes;